"use client";

import React from "react";
import { Activity, MapPin, Terminal, Cpu, Network } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function TechnicalIndex() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3 text-muted-foreground animate-pulse">
        <div>[FETCHING_DATA...]</div>
        <div>[ESTABLISHING_LINK...]</div>
        <div>[STANDBY...]</div>
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <div className="text-muted-foreground">[NO_INDEX_FOUND]</div>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-2 group w-fit">
            <span className="opacity-0 group-hover:opacity-100 text-primary transition-opacity duration-200">
              &gt;
            </span>
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function SystemFooter() {
  const socials = [{
    name: "LINKEDIN_NODE",
    url: "#"
  }, {
    name: "GITHUB_REPO",
    url: "#"
  }, {
    name: "X_BROADCAST",
    url: "#"
  }];
  return <section id="system-footer" className="dark bg-background text-foreground py-16 px-6 md:px-12 border-t border-border font-mono text-[12px] uppercase tracking-wider">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
        {}
        <div className="flex flex-col gap-6">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598652/img/exergy_systems_logo_terminal.png" alt="Exergy Systems" className="h-7 w-auto object-contain object-left opacity-90" />
          <div className="flex flex-col gap-3 text-muted-foreground">
            <div className="flex items-start gap-3">
              <MapPin className="size-4 shrink-0 text-primary mt-0.5" />
              <div className="flex flex-col">
                <span className="text-foreground">HQ_LOCATION</span>
                <span>City, State</span>
                <span>1234 Industrial Way</span>
              </div>
            </div>
            <div className="flex items-start gap-3 mt-2">
              <Terminal className="size-4 shrink-0 text-primary mt-0.5" />
              <div className="flex flex-col">
                <span className="text-foreground">CONTACT_PROTOCOL</span>
                <span>+1-555-1012-3456</span>
                <span>contact@exerygsystems.com</span>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="flex flex-col gap-6">
          <div className="flex items-center gap-2 text-foreground border-b border-border/50 pb-2">
            <Cpu className="size-4 text-primary" />
            <span>RESOURCES</span>
          </div>
          <MenuProvider menu_id="17">
            <TechnicalIndex />
          </MenuProvider>
        </div>

        {}
        <div className="flex flex-col gap-6">
          <div className="flex items-center gap-2 text-foreground border-b border-border/50 pb-2">
            <Network className="size-4 text-primary" />
            <span>NETWORK</span>
          </div>
          <ul className="flex flex-col gap-3">
            {socials.map((social, i) => <li key={social.name} data-index={i}>
                <Link to={social.url} className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-2 group w-fit">
                  <span className="text-primary/50 group-hover:text-primary transition-colors">
                    [+]
                  </span>
                  {social.name}
                </Link>
              </li>)}
          </ul>
        </div>

        {}
        <div className="flex flex-col gap-6">
          <div className="flex items-center gap-2 text-foreground border-b border-border/50 pb-2">
            <Activity className="size-4 text-primary" />
            <span>STATUS</span>
          </div>
          <div className="flex flex-col gap-4 items-start bg-card/50 p-4 border border-border/50">
            <div className="flex items-center gap-2 text-muted-foreground">
              <span className="inline-block size-2 bg-primary animate-pulse shadow-[0_0_8px_var(--color-primary)]"></span>
              <span>UPLINK: ACTIVE</span>
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <span className="inline-block size-2 bg-primary animate-pulse shadow-[0_0_8px_var(--color-primary)]" style={{
              animationDelay: "500ms"
            }}></span>
              <span>AI_CORE: NOMINAL</span>
            </div>
            <div className="mt-2">
              <Badge variant="outline" className="border-primary text-primary bg-primary/10 rounded-none font-mono text-[10px] tracking-widest px-3 py-1.5">
                ALL SYSTEMS OPERATIONAL
              </Badge>
            </div>
          </div>
          <div className="text-muted-foreground/50 text-[10px] mt-auto pt-4">
            © {new Date().getFullYear()} EXERGY SYSTEMS. ALL RIGHTS RESERVED.
          </div>
        </div>
      </div>
    </section>;
}